import React from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'

export const Error = ({ errorNumber }) => {
  const navigate = useNavigate()

  const navigateToMain = () => {
    navigate('/main/main')
  }
  return (
    <div
      className="d-flex justify-content-center align-items-center flex-column vh-100"
      style={{ minHeight: '600px' }}
    >
      <div>
        <b className="gradation">{errorNumber === 403 ? 403 : 404}</b>
        <div id="red-dot" />
      </div>
      <hr
        style={{
          width: '520px',
          color: '#DBDBDB',
          position: 'relative',
          top: '-42px',
        }}
      />
      <p style={{ fontSize: '27px' }}>
        {errorNumber === 403
          ? `죄송합니다. 접근이 거부되었습니다.`
          : `죄송합니다. 페이지를 찾을 수 없습니다.`}
      </p>
      <p className="text-center mt-4 mb-5 fs-20" style={{ color: '#6D6D69' }}>
        {errorNumber === 403
          ? `요청하신 페이지의 접근이 거부되었습니다.`
          : `지금 입력하신 주소는 사라졌거나 다른 페이지로 변경되었습니다.`}
        <br />
        입력하신 주소가 정확한지 다시 확인해주세요.
      </p>
      <a href='/'>
        <button className="gray-button mt-2" onClick={navigateToMain}>
          메인 페이지로 이동
        </button>
      </a>
    </div>
  )
}
Error.propTypes = {
  errorNumber: PropTypes.number, // 에러 번호
}
